var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5V0.875L4 4.375L7.5 7.875V5.25C10.3962 5.25 12.75 7.60375 12.75 10.5C12.75 11.3837 12.5312 12.2237 12.1375 12.95L13.415 14.2275C14.0975 13.1512 14.5 11.8737 14.5 10.5C14.5 6.6325 11.3675 3.5 7.5 3.5ZM7.5 15.75C4.60375 15.75 2.25 13.3962 2.25 10.5C2.25 9.61625 2.46875 8.77625 2.8625 8.05L1.585 6.7725C0.9025 7.84875 0.5 9.12625 0.5 10.5C0.5 14.3675 3.6325 17.5 7.5 17.5V20.125L11 16.625L7.5 13.125V15.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.d1f120f1.svg";
export { ForwardRef as ReactComponent };